// Separate module so tests can mock it: jsdom no longer allows redefining window.location.
export const reloadPage = () => window.location.reload();
